import React from "react";
import SecondaryHeader from "../../components/SecondaryHeader/SecondaryHeader";
import PatrolComponent from "../../components/PatrolBarcodeComponent/PatrolComponent";

const Profile: React.FC = () => {
  return (
    <div>
      <SecondaryHeader title="Absen" pathname="/home" />
      <PatrolComponent />
    </div>
  );
};

export default Profile;
